import { ScrollView } from 'react-native';
import React from 'shared-react';

const timeoutPromise = (
  seconds: number,
  getTmt: () => number,
  setTmt: (tmt: number) => void,
) => new Promise(res => {
  clearTimeout(getTmt());
  setTmt(setTimeout(res, seconds) as unknown as number);
});

const useTmt = () => {
  const tmt = React.useRef<number>(null);
  const setTmt = (newTmt: number) => { tmt.current = newTmt; };
  return [
    () => tmt.current,
    setTmt,
  ] as const;
};

export default (desktopScrollParentSelector?: string) => {
  const mobileScrollParentRef = React.useRef<{ scrollTo: ScrollView['scrollTo'] }>(null);
  const [getTmt, setTmt] = useTmt();

  const scrollToY = async (y: number, timeoutSeconds: number) => {
    await timeoutPromise(timeoutSeconds, getTmt, setTmt);

    if (desktopScrollParentSelector && !mobileScrollParentRef.current) {
      const desktopScrollParentRef = document.querySelector(desktopScrollParentSelector);
      desktopScrollParentRef?.scrollTo(0, y);
    } else if (mobileScrollParentRef.current) {
      mobileScrollParentRef.current?.scrollTo({
        y,
        x: 0,
        animated: false,
      });
    }
  };

  React.useEffect(() => () => {
    // unmount
    clearTimeout(getTmt());
  }, []);

  return [
    mobileScrollParentRef,
    React.useCallback<typeof scrollToY>(
      scrollToY,
      [desktopScrollParentSelector],
    ),
  ];
};
